<div class="bk-white mb-4">
  <div class="d-flex gap-2">
    <div class="qrcode-container">
      <div
        class="container_"
        *ngIf="
          order.approvalStatus === ApprovalStatusEnum.WaitingApproval ||
          order.approvalStatus === ApprovalStatusEnum.DeclinedApproval
        "
      >
        <div class="tag">
          <h6
            *ngIf="order.approvalStatus === ApprovalStatusEnum.WaitingApproval"
          >
            {{ "WaitingApproval" | translate }}
          </h6>
          <h6
            *ngIf="order.approvalStatus === ApprovalStatusEnum.DeclinedApproval"
          >
            {{ "Rejected" | translate }}
          </h6>
        </div>
        <img
          src="{{
            'https://api.qrserver.com/v1/create-qr-code/?data=' +
              order.id +
              '&margin=30&height=100&width=100'
          }}"
          alt=""
          style="opacity: 0.4"
          class="image"
        />
      </div>

      <img
        *ngIf="order.approvalStatus === ApprovalStatusEnum.Approved"
        src="{{
          'https://api.qrserver.com/v1/create-qr-code/?data=' +
            order.id +
            '&margin=30&height=100'
        }}"
        alt=""
      />
    </div>
    <div class="d-block w-100">
      <div class="d-flex justify-content-between">
        <p class="ticket-name">
          {{ helpers.getElementTranslatedName(order?.ticket) }}
        </p>
        <p class="ticket-name" *ngIf="order.total > 0">
          <span
            [innerHTML]="
              order.total
                | number : '1.2-2'
                | customCurrency : 'SAR' : 'symbol' : '#555770' : 35
            "
          ></span>
        </p>
        <p class="ticket-name" *ngIf="order.total === 0">
          {{ "free" | translate }}
        </p>
      </div>
      <div *ngIf="!order.schedule">
        <p class="time">
          {{
            "come-anytime-days"
              | translate
                : {
                    day1:
                      event.schedules[0]?.startAt * 1000
                      | localizedDate : "d MMM" : translate.currentLang,
                    day2:
                      event.schedules[event.schedules.length - 1]?.startAt *
                        1000
                      | localizedDate : "MMM d, y" : translate.currentLang,
                    t1:
                      event.schedules[0]?.startAt * 1000
                      | localizedDate : "hh:mm a" : translate.currentLang,
                    t2:
                      event.schedules[event.schedules.length - 1]?.startAt *
                        1000 | localizedDate : "hh:mm a" : translate.currentLang
                  }
          }}

          <!-- {{
            order?.schedule?.endAt * 1000
              | localizedDate : "hh:mm a" : translate.currentLang
          }} -->
        </p>
      </div>
      <div *ngIf="order.schedule">
        <div class="d-flex gap-3 mobile">
          <div class="d-flex gap-1 align-items-center">
            <img style="width: 25px" src="assets/images/tickets/calendar.svg" />
            <p class="mb-0 time" style="direction: ltr">
              {{
                order?.schedule?.startAt * 1000
                  | localizedDate : "EEEE, MMM d, y" : translate.currentLang
              }}
            </p>
          </div>

          <div class="d-flex align-items-center gap-1">
            <img style="width: 25px" src="assets/images/tickets/clock.svg" />
            <p *ngIf="order?.time" class="mb-0 time" style="direction: ltr">
              {{ order?.time?.startAt }}
            </p>

            <p *ngIf="!order?.time" class="mb-0 time" style="direction: ltr">
              {{ "come-anytime" | translate }}
              {{
                order?.schedule?.startAt * 1000
                  | localizedDate : "hh:mm a" : translate.currentLang
              }}
              {{ "to" | translate }}
              {{
                order?.schedule?.endAt * 1000
                  | localizedDate : "hh:mm a" : translate.currentLang
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
